import { render, staticRenderFns } from "./AsideFixed.vue?vue&type=template&id=0b3ebeb4&scoped=true"
import script from "./AsideFixed.vue?vue&type=script&lang=js"
export * from "./AsideFixed.vue?vue&type=script&lang=js"
import style0 from "./AsideFixed.vue?vue&type=style&index=0&id=0b3ebeb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3ebeb4",
  null
  
)

export default component.exports